import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZLocaleModule } from '@knz/theme';
import { KNZUtilModule } from '@knz/util';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { TagSelectComponent } from './tag-select.component';

const COMPONENTS = [TagSelectComponent];

@NgModule({
  imports: [CommonModule, NzIconModule, KNZLocaleModule, KNZUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class TagSelectModule {}
